import './components/uc-element-sorter';
import './components/uc-theme-picker';
import './components/uc-milestone-manager';
import './components/uc-media-upload';
import './components/uc-free-product-manager';
import './page/uc-config-page';
import './page/uc-milestones-page';
import './page/uc-free-products-page';
import './page/uc-cross-sell-rules-page';

import deDE from './snippet/de-DE.json';
import enGB from './snippet/en-GB.json';

Shopware.Module.register('sellops-ultimate-cart', {
    type: 'plugin',
    name: 'Ultimate Cart',
    title: 'sellops-ultimate-cart.general.mainMenuLabel',
    description: 'sellops-ultimate-cart.general.description',
    color: '#0f69c4',
    icon: 'regular-shopping-cart',

    snippets: {
        'de-DE': deDE,
        'en-GB': enGB,
    },

    navigation: [
        {
            id: 'sellops-ultimate-cart',
            label: 'sellops-ultimate-cart.general.mainMenuLabel',
            color: '#0f69c4',
            icon: 'regular-shopping-cart',
            path: 'sellops.ultimate.cart.config',
            parent: 'sw-extension',
            position: 100,
        },
        {
            id: 'sellops-ultimate-cart-config',
            label: 'sellops-ultimate-cart.general.configMenuLabel',
            path: 'sellops.ultimate.cart.config',
            parent: 'sellops-ultimate-cart',
            position: 10,
        },
        {
            id: 'sellops-ultimate-cart-milestones',
            label: 'sellops-ultimate-cart.milestones.navLabel',
            path: 'sellops.ultimate.cart.milestones',
            parent: 'sellops-ultimate-cart',
            position: 20,
        },
        {
            id: 'sellops-ultimate-cart-freeproducts',
            label: 'sellops-ultimate-cart.freeProducts.pageTitle',
            path: 'sellops.ultimate.cart.freeproducts',
            parent: 'sellops-ultimate-cart',
            position: 30,
        },
        {
            id: 'sellops-ultimate-cart-crosssellrules',
            label: 'sellops-ultimate-cart.crossSellRules.navLabel',
            path: 'sellops.ultimate.cart.crosssellrules',
            parent: 'sellops-ultimate-cart',
            position: 40,
        },
    ],

    routes: {
        config: {
            component: 'uc-config-page',
            path: 'config',
            meta: {
                privilege: 'system.plugin_maintain',
            },
        },
        milestones: {
            component: 'uc-milestones-page',
            path: 'milestones',
            meta: {
                privilege: 'system.plugin_maintain',
            },
        },
        freeproducts: {
            component: 'uc-free-products-page',
            path: 'freeproducts',
            meta: {
                privilege: 'system.plugin_maintain',
            },
        },
        crosssellrules: {
            component: 'uc-cross-sell-rules-page',
            path: 'crosssellrules',
            meta: {
                privilege: 'system.plugin_maintain',
            },
        },
    },
});
